import React from 'react';
import styled from 'styled-components';
import { Grid, GridSize } from '@beeline.com/bp-design-system';

export interface DrawerColumnSplit {
  left: number;
  right: number;
}
interface Props {
  label: string;
  dataTest: string;
  columnSplit?: DrawerColumnSplit;
  rightAlign?: boolean;
}

export const DrawerItemView: React.FC<React.PropsWithChildren<Props>> = ({
  label,
  children,
  dataTest,
  columnSplit,
  rightAlign = false
}) => {
  const split = columnSplit && columnSplit.left + columnSplit.right === 1 ? columnSplit : { left: 0.33, right: 0.67 };

  return (
    <StyledContainer container dataTest={dataTest} spacing={1} alignItems="center">
      <StyledLabel size={{ xs: 12, md: Math.round(split.left * 12) as GridSize }}>
        <div>{label}</div>
      </StyledLabel>
      <StyledContent size={{ xs: 12, md: Math.round(split.right * 12) as GridSize }} dataTest={`${dataTest}-value`}>
        <StyledDiv data-test="drawer-item" $rightAlign={rightAlign}>
          {children}
        </StyledDiv>
      </StyledContent>
    </StyledContainer>
  );
};

const StyledDiv = styled.div<{ $rightAlign: boolean }>`
  justify-content: ${({ $rightAlign }) => ($rightAlign ? 'end' : 'initial')};
  display: flex;
  flex-wrap: wrap;
`;

const StyledContainer = styled(Grid)`
  min-height: 2rem;
  font-size: ${({ theme }) => theme.font.sizeSmall};
`;

const StyledLabel = styled(Grid)`
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  align-items: start;
  align-self: start;
`;

const StyledContent = styled(Grid)`
  & div:nth-child(1) {
    align-items: center;
  }
`;
